import styled from "@emotion/styled";
import { selectV2Theme } from "../selectV2Theme";
export const SelectedValueWrapper = styled("div")`
    position: absolute;

    // very specifically match the position of the input.
    left: ${_ref => {
  let {
    isContentBeforeVisible,
    themeMode
  } = _ref;
  return isContentBeforeVisible ? selectV2Theme.input.padding.placeholder(themeMode) : selectV2Theme.input.padding.left(themeMode);
}};

    // Allow the text to clip properly.
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    // Give the formatted stuff the space it needs to breathe.
    display: flex;
    align-items: center;
    height: 100%;
`;
//# sourceMappingURL=SelectedValueWrapper.js.map